<template functional>
  <svg :fill="props.fill" class="icon icon--error" :class="props.classes" xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 59.1 59.1"><path d="M1 58.1L58.1 1M1 1l57.1 57.1"/><path d="M58.1 59.1c-.3 0-.5-.1-.7-.3L29.5 31 1.7 58.8c-.4.4-1 .4-1.4 0s-.4-1 0-1.4l27.8-27.8L.3 1.7C-.1 1.3-.1.7.3.3s1-.4 1.4 0l27.8 27.8L57.4.3c.4-.4 1-.4 1.4 0s.4 1 0 1.4L31 29.5l27.8 27.8c.4.4.4 1 0 1.4-.2.3-.4.4-.7.4z"/></svg>
</template>

<script>
export default {
  name: 'IconError',
  props: {
    fill: {
      type: String,
      default: ''
    },
    classes: {
      type: String,
      default: ''
    }
  }
}
</script>
